import {useMutation} from '@tanstack/react-query';
import {getLocalStorage} from '@/Utils/CommonUtils';
import ChessRestClient from '@/Api/ChessRestClient';

type CancelSessionVars = {
  session_id: number;
  reason?: string;
  cancellation_type: 'group' | 'personal';
  user_role: 'coach' | 'student' | 'parent';
};

export default function useCancelSessionApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const mutation = useMutation<any, Error, CancelSessionVars>(
    async (variables: CancelSessionVars) => {
      const token = await getLocalStorage('access_token');
      
      // Determine the endpoint based on cancellation type
      const endpoint = variables.cancellation_type === 'group' 
        ? 'subscription/v1/sessions/cancel-group/'
        : 'subscription/v1/sessions/cancel-personal/';
      
      const response = await ChessRestClient.post(
        endpoint,
        {
          webinar_id: variables.session_id,
          reason: variables.reason,
          user_role: variables.user_role,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );

      return response;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: error => {
        if (handleOnError) handleOnError(error);
      },
    },
  );

  return {
    ...mutation,
  };
}

